<template>
    <div class="members-preview" :class="{'members-preview_loading':loading}">
        <div class="members-preview__header">{{ title }}</div>
        <div class="members-preview__previews-container">
            <span v-for="user in members" :key="user.id">
                    <a
                            v-if="useSimpleLink"
                            :href="user.link"

                            style="text-decoration: none"
                            tabindex="-1"
                            :aria-label="user.name"
                    >
                    <div
                            class="member-preview"
                            :style="getAvatarStyle(user)"
                            v-tooltip="user.name"
                            aria-hidden="true"
                    >
                        <div class="member-preview__online_mark" v-if="user.online"></div>
                    </div>
                </a>
                <router-link
                        v-else
                        :to="user.link"
                        style="text-decoration: none"
                        tabindex="-1"
                        :aria-label="user.name"
                >
                    <div
                            class="member-preview"
                            :style="getAvatarStyle(user)"
                            v-tooltip="user.name"
                            aria-hidden="true"
                    >
                        <div class="member-preview__online_mark" v-if="user.online"></div>
                    </div>
                </router-link>
            </span>


            <i class="fas fa-circle-notch fa-spin members-preview__loading-mark" v-if="loading"></i>
        </div>
        <div class="members-preview__see-all" v-if="membersLink"
             :class="{'members-preview__see-all_active': seeAllLinkHighlighted}">
            <router-link
                    :to="membersLink"
                    tabindex="-1"
            >{{ seeAllText }}
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LeftMenuMembersListPreview",
        props: {
            title: {
                type: String,
                default: 'Circle',
            },

            seeAllText: {
                type: String,
                default: 'See all Circle Members',
            },

            endpoint: Function,
            endpointKey: Number,
            membersLink: {
                type: Object,
                required: false
            },
            useSimpleLink: {
                type: Boolean,
                default: false,
            },
            seeAllLinkHighlighted: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                loading: false,
                members: [],
            };
        },
        methods: {
            getAvatarStyle(user) {
                return {'background-image': `url('${user.avatar}')`};
            },
            loadRandomFMembers() {
                this.loading = true;
                this.endpoint(this.endpointKey)
                    .then(resp => {
                        this.members = resp.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.loadRandomFMembers();
        }
    };
</script>

<style scoped lang="scss">
  @import "../../angular/app/styles/mixins";
  @import "../../angular/app/styles/const";

  .members-preview {
    margin-top: 10px;
    background-color: #0065b0;
    border-radius: 5px;
    padding-bottom: 25px;
    position: relative;

    &_loading {
      min-height: 292px;
    }

    &__header {
      color: white;
      font-weight: bolder;
      text-align: center;
      font-size: 21px;
    }

    &__previews-container {
      text-align: center;
      position: relative;
    }

    &__loading-mark {
      position: absolute;
      top: 80px;
      left: 125px;
      color: white;
      font-size: 71px;
    }

    &__see-all {
      position: absolute;
      text-align: center;
      color: white;
      bottom: 0;
      display: block;
      font-size: 20px;
      width: 100%;
      cursor: pointer;

      &_active {
        font-weight: bolder;
      }

      a {
        color: #fff;

        &:focus, &:active {
          font-weight: bold;
        }
      }
    }
  }

  .member-preview {
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 70px;
    height: 70px;
    background-color: white;
    border-radius: 50%;
    background-size: cover;
    border: solid 2px white;
    margin: 2px 8px;

    &__online_mark {
      width: 30px;
      height: 30px;
      right: -5px;
      bottom: -5px;
      border-radius: 50%;
      background-color: $online-green;
      position: absolute;
      border: solid 2px white;
    }
  }
</style>